import { hhmmADoMMMYYYY, isNullUndefinedAndEmpty } from '@fareye/utils'
import React from 'react'
import { parseDoorData, parseTemperature, useTranslation } from '@fareye/common'

export function VehicleInfoWindow({ data }: { data: any }) {
  const { t } = useTranslation()
  const { landmark, speed, state, istTimestamp, extraData = {} } = data || {}
  let speedStr = `${isNullUndefinedAndEmpty(speed) ? '-' : speed + ' Km/hr'}`
  let temperature = parseTemperature(
    extraData?.temperature ?? extraData?.sensorData
  )
  const doorsData = parseDoorData(extraData?.sensorData)
  return (
    <>
      <h5>
        <strong>{t('Tracking Details')} :</strong>
      </h5>
      <hr />
      {landmark && (
        <>
          <strong>{t('Landmark')}</strong>: {landmark}
          <br />
        </>
      )}
      <strong>{t('Speed')}</strong>: {speedStr}
      <br />
      {state && (
        <>
          <strong>{t('Vehicle Status')}</strong>: {t(state)}
          <br />
        </>
      )}
      {temperature && (
        <>
          <strong>{t('Temperature')}</strong>: {`${temperature} °C`}
          <br />
        </>
      )}
      {doorsData && (
        <>
          <strong>{t('Doors')}</strong>: {doorsData}
          <br />
        </>
      )}
      {extraData?.tampering && (
        <>
          <strong>{t('Tampering')}</strong>: {extraData?.tampering}
          <br />
        </>
      )}
      {istTimestamp && (
        <>
          <strong>{t('Last Updated')}</strong>:{hhmmADoMMMYYYY(istTimestamp)}
        </>
      )}
    </>
  )
}
